/** Race an operation against cancellation, including operations that ignore AbortSignal. */
export function waitForShopifyOperation<T>(
  signal: AbortSignal | null | undefined,
  operation: () => Promise<T>,
): Promise<T> {
  if (!signal) return operation()
  if (signal.aborted) return Promise.reject(signal.reason)
  return new Promise<T>((resolve, reject) => {
    const onAbort = () => reject(signal.reason)
    signal.addEventListener('abort', onAbort, { once: true })
    // Defer invocation so synchronous throws also clean up the listener. Re-check
    // cancellation before invoking a token request or fetch in this microtask.
    Promise.resolve()
      .then(() => {
        signal.throwIfAborted()
        return operation()
      })
      .then(resolve, reject)
      .finally(() => signal.removeEventListener('abort', onAbort))
  })
}
